import styled from '@emotion/styled'

export const StyleUploadButtonWrapper = styled.div<any>`
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 4px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  padding: 0px 10px;
  overflow: hidden;
`

export const StyleUploadButton = styled.div<any>`
  background: ${(props) => props.theme.colors.primary};
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.white};
  padding: 0px 30px;
  border-radius: 4px;
  font-size: 12px;
`

export const StyleFileDashed = styled.div<any>`
  border: 1px dashed
    ${(props: any) =>
      !!props?.hasError
        ? props.theme.colors.red800
        : props.theme.colors.grey200};
  border-radius: 4px;
  width: 100%;
  height: ${(props: any) => (props?.size ? `${props?.size}px` : '100px')};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
`
export const RemoveIcon = styled.div<any>`
  position: absolute;
  width: 24px;
  height: 24px;
  background-color: blue;
  border-radius: 99px;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
`
export const StyleUploadInput = styled.input`
  display: none;
`

export const StyleUploadButtonImgPreview = styled.img`
  width: 50px;
  height: 40px;
  border-radius: 4px;
`

export const StyleFilePlaceholder = styled.p<any>`
  font-size: 14px;
  display: flex;
  align-items: center;
  color: ${(props: any) => props.theme.colors.grey300};
`

export const StyleGalleryCard = styled.div<any>`
  background-color: rgba(227, 227, 236, 0.2);
  display: flex;
  border-radius: 8px;
  width: ${(props) => (props.size ? `${props.size}px` : '100%')};
  height: ${(props) => (props.size ? `${props.size}px` : '100%')};
  min-height: 68px;
  min-width: 68px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
`

export const StyleFileAvatar = styled.div<any>`
  position: relative;
  border: 1px solid
    ${(props: any) =>
      !!props?.hasError
        ? props.theme.colors.red800
        : props.theme.colors.grey200};
  width: ${(props: any) => (props?.size ? `${props?.size}px` : '100px')};
  height: ${(props: any) => (props?.size ? `${props?.size}px` : '100px')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
`

export const StyleFileAvatarIcon = styled.div`
  background-color: ${(props: any) => props.theme.colors.adminBg};
  position: absolute;
  border: 1px solid
    ${(props: any) =>
      !!props?.hasError
        ? props.theme.colors.red800
        : props.theme.colors.grey200};
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 4px;
  bottom: 0px;
  right: 10px;
`
